import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';
import { MenuContext } from "../context/MenuContext";
import { BiMoneyWithdraw } from "react-icons/bi";
import { InventorySupplyModal } from "../components/supply_modal";
import { InventoryDeductModal } from "../components/deduct_modal";
import { MdOutlineWarehouse } from "react-icons/md";


export default function ViewInventoryHistory() {
    // const navigate = useNavigate();
    const {logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [bookingList, setBookingList] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [offset, setOffset] = useState(0);
    const [pagination] = useState('');
    const { menuOpen, setMenuOpen } = useContext(MenuContext)
    const [pageData, setPageData] = useState({});
    const [showSupplyModal, setShowSupplyModal] = useState(false);
    const [showDeductModal, setShowDeductModal] = useState(false);
    const [itemUpdating, setItem] = useState({});
    const {product_id, product_name} = useParams();
    const {state} = useLocation();

    useEffect(() => {
        if (menuOpen) setMenuOpen(false);
        getData();
    }, [])

    useEffect(() => {
        getData();
    }, [offset])

    function changePage(type) {
        if (type == "next") {
            setOffset(offset + 20);
        } else {
            setOffset(offset - 20);
        }
    }

    async function getData() {
        const formData = new FormData();
        // Object.entries(formFields).forEach(([key, value]) => {
        //   formData.append(key, value);
        // });
        formData.append('product_id', product_id);
        formData.append('offset', offset);
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_inventory_history.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
              setBookingList(response.data.records);
              setPageData({ stock_value: response.data.stock_val, sale_value: response.data.sale_val, total_in_stock: response.data.total_in_stock })
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
      {showSupplyModal &&
        <InventorySupplyModal
            setShowSupplyModal={setShowSupplyModal}
            getData={getData}
            item={itemUpdating}
        />
      }
      {showDeductModal &&
        <InventoryDeductModal
            setShowDeductModal={setShowDeductModal}
            getData={getData}
            item={itemUpdating}
        /> 
      }
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#7d5af6'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
        {/* <h2 className="text-2xl text-[#037684] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, Admin`} />
        <div className="py-6 px-6 flex flex-col justify-start">
            <div className="animate-fadeIn mt-0 w-full bg-white rounded-3xl border p-6 shadow-sm grid grid-cols-3 md:grid-cols-3">
                <div className="flex-1">
                <label className="flex items-center gap-2 text-gray-500 text-xs md:text-sm mb-1">
                    <MdOutlineWarehouse className="w-5 h-5" />
                    Avg. Stock Value
                </label>

                <div className="relative">
                    <p className="font-bold text-2xl md:text-3xl">{pageData?.stock_value}</p>
                </div>
                </div>
                <div className="flex-1">
                <label className="flex items-center gap-2 text-gray-500 text-xs md:text-sm mb-1">
                    <BiMoneyWithdraw className="w-5 h-5" />
                    Expected Sale Value
                </label>

                <div className="relative">
                    <p className="font-bold text-2xl md:text-3xl">{pageData?.sale_value}</p>
                </div>
                </div>
                <div className="flex-1">
                <label className="flex items-center gap-2 text-gray-500 text-xs md:text-sm mb-1">
                    <MdOutlineWarehouse className="w-5 h-5" />
                    Total In Stock
                </label>

                <div className="relative">
                    <p className="font-bold text-2xl md:text-3xl">{pageData?.total_in_stock}</p>
                </div>
                </div>
            </div>
            <div className="gap-y-2 md:gap-y-0 flex flex-col mt-3 md:mt-7 md:flex-row md:items-center justify-between">
                <h2 className="text-xl md:text-2xl text-black font-bold">{'Inventory: ' + product_name}</h2>
                <div className="flex items-center self-end">
                    <div className="w-auto flex items-center justify-between border rounded-xl p-2 gap-x-2">
                        <div onClick={() => { setShowSupplyModal(true);setItem(state.row) }} className="flex items-center justify-center cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-[#037684] bg-[#037684] text-white font-semibold text-center text-xs">{'Add Stock'}</div>
                        <div onClick={() => { setShowDeductModal(true);setItem(state.row) }} className="flex items-center justify-center cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-[#ff0000] bg-[#ff0000] text-white font-semibold text-center text-xs">{'Remove Stock'}</div>
                    </div>
                </div>
            </div>
            <div className='overflow-x-auto mt-5'>
                <table className="w-full table-auto border-collapse text-sm md:text-[15px]">
                    <thead className="bg-gray-50 border-b">
                    <tr>
                        <th className="hidden md:table-cell px-2 py-4">
                            <div className="flex items-center gap-1">#</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Variation</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Quantity</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Type</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Action By</div>
                        </th>
                        <th className="hidden md:table-cell text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Time</div>
                        </th>
                    </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {bookingList?.map((row, index) => (
                            <tr
                            key={index}
                            className={index % 2 === 0 ? "bg-white animate-fadeIn" : "bg-gray-50 animate-fadeIn"}
                            >
                                <td className="hidden md:table-cell px-2 py-2">
                                    {++index}
                                </td>
                                <td className="hidden md:table-cell px-2 py-2">
                                    {row.option}
                                </td>
                                <td className={`px-2 py-2 font-semibold ${row.transaction_type == "Added" ? 'text-[#00b47a]' : 'text-[#ff0000]'}`}>
                                    {row.transaction_type == "Added" ? '+' : '-'}{row.quantity}
                                </td>
                                <td className="px-2 py-2 font-semibold">
                                    {row.transaction_type}
                                </td>
                                <td className="px-2 py-2">
                                    {row.action_by}
                                </td>
                                <td className="px-2 py-2">
                                    {row.time}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='w-full flex justify-end mt-6'>
                <div className='flex flex-col items-center'>
                    <div className="flex items-center space-x-2 border border-gray-300 rounded-lg px-1 py-1 w-fit bg-white">
                        <button
                            onClick={() => changePage('prev')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Prev.
                        </button>
                        <button
                            onClick={() => changePage('next')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Next
                        </button>
                    </div> 
                    <label className='text-sm mt-2'>{pagination}</label>
                </div>
            </div>
        </div>
    </div>
  );
}
